export default __webpack_public_path__ + "static/media/uncheck_1.6e605aa0.mp3";